import React from 'react';
import { DivideIcon as LucideIcon } from 'lucide-react';

interface KPICardProps {
  title: string;
  value: string;
  previousValue: string;
  change: number;
  icon: typeof LucideIcon;
  iconColor: string;
  format?: string;
  hideComparison?: boolean;
  barRatio?: number;
}

const KPICard: React.FC<KPICardProps> = ({
  title,
  value,
  previousValue,
  change,
  icon: Icon,
  iconColor,
  format = '',
  hideComparison = false,
  barRatio = 1,
}) => {
  const barWidth = change === 0 ? 0 : Math.max(Math.min(Math.abs(change) * barRatio, 100), 10);

  return (
    <div className={`bg-white rounded-lg border border-gray-200 p-6 shadow-sm transition-all hover:shadow-md${hideComparison ? ' p-6' : ''}`}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium text-gray-500">{title}</h3>
        <Icon className={`w-5 h-5 ${iconColor}`} />
      </div>
      
      <div className={`flex items-end gap-2${!hideComparison ? ' mb-2' : ''}`}>
        <span className="text-3xl font-bold text-gray-900">
          {value}
          <span className="text-lg ml-1">{format}</span>
        </span>
      </div>
      
      {!hideComparison && (
        <>
          <div className="mt-2 flex items-center">
            <span className={`text-sm font-medium ${change >= 0 ? 'text-green-500' : 'text-red-500'}`}>{change >= 0 ? '+' : ''}{change.toFixed(1)}%</span>
            <span className="mx-2 text-gray-500">vs</span>
            <span className="text-sm text-gray-500">{previousValue}{format}</span>
          </div>
          <div className="mt-4 h-2 w-full bg-gray-100 rounded-full overflow-hidden">
            <div 
              className={`h-full ${change >= 0 ? 'bg-green-500' : 'bg-red-500'} rounded-full transition-all duration-500 ease-in-out`}
              style={{ width: `${barWidth.toFixed(2)}%` }}
            ></div>
          </div>
        </>
      )}
    </div>
  );
};

export default KPICard;